module.exports = __webpack_public_path__ + "../resources/img/ic_re_clear_cloudy_solid.9ede3797.svg";